import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path
      d="M12 22C6.486 22 2 17.514 2 12C2 6.486 6.486 2 12 2C17.514 2 22 6.486 22 12C22 17.514 17.514 22 12 22ZM12 3.111C7.099 3.111 3.111 7.099 3.111 12C3.111 16.901 7.099 20.889 12 20.889C16.901 20.889 20.889 16.901 20.889 12C20.889 7.099 16.901 3.111 12 3.111V3.111Z"
      fill="currentColor"
    />
    <path
      d="M10.37 9.87898C10.37 10.626 9.76502 11.231 9.01802 11.231C8.27102 11.231 7.66602 10.626 7.66602 9.87898C7.66602 9.13198 8.27102 8.52698 9.01802 8.52698C9.76502 8.52698 10.37 9.13198 10.37 9.87898Z"
      fill="currentColor"
    />
    <path
      d="M16.3339 9.87898C16.3339 10.626 15.7289 11.231 14.9819 11.231C14.2349 11.231 13.6299 10.626 13.6299 9.87898C13.6299 9.13198 14.2349 8.52698 14.9819 8.52698C15.7289 8.52698 16.3339 9.13198 16.3339 9.87898Z"
      fill="currentColor"
    />
    <path
      d="M8.17604 17.52C8.08204 17.52 7.98604 17.496 7.89804 17.445C7.63204 17.291 7.54204 16.951 7.69604 16.685C8.58304 15.154 10.232 14.202 12 14.202C13.768 14.202 15.417 15.153 16.303 16.684C16.457 16.95 16.366 17.289 16.101 17.444C15.836 17.596 15.496 17.508 15.341 17.242C14.652 16.053 13.372 15.314 11.999 15.314C10.626 15.314 9.34504 16.053 8.65604 17.243C8.55404 17.42 8.36804 17.52 8.17604 17.52Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'SmileySad');

export default Icon;
